import { render, staticRenderFns } from "./PersonalDetailsComponent.vue?vue&type=template&id=710b597c"
import script from "./PersonalDetailsComponent.vue?vue&type=script&lang=ts"
export * from "./PersonalDetailsComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports